import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const AnalyticsModal = ({ gallery, onClose }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleDateString('en-US', { 
      month: 'short', 
      day: 'numeric', 
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className="fixed inset-0 z-[2000] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm overflow-y-auto">
      <div className="bg-card border border-border rounded-xl w-full max-w-3xl shadow-warm-xl my-8">
        <div className="flex items-center justify-between p-4 md:p-6 border-b border-border">
          <div>
            <h2 className="text-xl font-semibold mb-1">Gallery Analytics</h2>
            <p className="text-sm text-muted-foreground">{gallery?.name}</p>
          </div>
          <button
            onClick={onClose}
            className="p-2 rounded-lg hover:bg-muted smooth-transition"
            aria-label="Close modal"
          >
            <Icon name="X" size={20} />
          </button>
        </div>

        <div className="p-4 md:p-6 space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="bg-muted rounded-lg p-4">
              <div className="flex items-center gap-2 mb-2">
                <Icon name="Eye" size={20} color="var(--color-primary)" />
                <span className="text-sm text-muted-foreground">Total Views</span>
              </div>
              <p className="text-2xl font-semibold data-text">{gallery?.analytics?.totalViews}</p>
            </div>
            <div className="bg-muted rounded-lg p-4">
              <div className="flex items-center gap-2 mb-2">
                <Icon name="Download" size={20} color="var(--color-success)" />
                <span className="text-sm text-muted-foreground">Downloads</span>
              </div>
              <p className="text-2xl font-semibold data-text">{gallery?.analytics?.totalDownloads}</p>
            </div>
            <div className="bg-muted rounded-lg p-4">
              <div className="flex items-center gap-2 mb-2">
                <Icon name="Clock" size={20} color="var(--color-accent)" />
                <span className="text-sm text-muted-foreground">Avg. Time</span>
              </div>
              <p className="text-2xl font-semibold data-text">{gallery?.analytics?.avgViewTime}</p>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Recent Visitors</h3>
            <div className="space-y-3 max-h-64 overflow-y-auto">
              {gallery?.analytics?.recentVisitors?.map((visitor) => (
                <div key={visitor?.id} className="bg-muted rounded-lg p-4 flex items-start justify-between gap-4">
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-1">
                      <Icon name="User" size={16} color="var(--color-muted-foreground)" />
                      <p className="font-medium">{visitor?.name}</p>
                    </div>
                    <div className="flex flex-col gap-1 text-sm text-muted-foreground">
                      <div className="flex items-center gap-2">
                        <Icon name="Mail" size={14} />
                        <span className="truncate">{visitor?.email}</span>
                      </div>
                      <div className="flex items-center gap-2">
                        <Icon name="Phone" size={14} />
                        <span>{visitor?.phone}</span>
                      </div>
                    </div>
                  </div>
                  <div className="text-right flex-shrink-0">
                    <p className="text-xs text-muted-foreground mb-1">Last Visit</p>
                    <p className="text-xs data-text">{formatDate(visitor?.lastVisit)}</p>
                    <div className="flex items-center gap-1 mt-2">
                      <Icon name="Download" size={12} color="var(--color-success)" />
                      <span className="text-xs data-text">{visitor?.downloads}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Popular Downloads</h3>
            <div className="space-y-2">
              {gallery?.analytics?.popularDownloads?.map((item, index) => (
                <div key={index} className="flex items-center justify-between p-3 bg-muted rounded-lg">
                  <div className="flex items-center gap-3 flex-1 min-w-0">
                    <Icon name="Image" size={20} color="var(--color-muted-foreground)" />
                    <span className="text-sm truncate">{item?.fileName}</span>
                  </div>
                  <div className="flex items-center gap-2 flex-shrink-0">
                    <Icon name="Download" size={16} color="var(--color-success)" />
                    <span className="text-sm font-medium data-text">{item?.count}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="flex gap-3 p-4 md:p-6 border-t border-border">
          <Button
            variant="outline"
            onClick={onClose}
            fullWidth
          >
            Close
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AnalyticsModal;